const rawBackendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
const rawCasterWidgetType = process.env.REACT_APP_CASTER_WIDGET_TYPE || 'podcastsPlayer';
const rawCasterPublicToken = process.env.REACT_APP_CASTER_PUBLIC_TOKEN || '';
const rawCasterChannelId = process.env.REACT_APP_CASTER_CHANNEL_ID || '';
const rawCasterTheme = process.env.REACT_APP_CASTER_WIDGET_THEME || 'light';
const rawCasterColor = process.env.REACT_APP_CASTER_WIDGET_COLOR || 'e81e4d';

export const BACKEND_URL = rawBackendUrl.replace(/\/+$/, '');
export const API_BASE = `${BACKEND_URL}/api`;

export const CASTER_WIDGET = {
  enabled: Boolean(rawCasterPublicToken && rawCasterChannelId),
  type: rawCasterWidgetType,
  publicToken: rawCasterPublicToken,
  channelId: rawCasterChannelId,
  theme: rawCasterTheme,
  color: rawCasterColor.replace(/^#/, ''),
  scriptSrc: 'https://cdn.cloud.caster.fm/widgets/embed.js',
};
